export const socialLinks = {
  linkedin: 'https://www.linkedin.com/company/gmg-automation-it/',
  facebook: 'https://web.facebook.com/gmgautomation',
  instagram: 'https://www.instagram.com/gmgautomation/',
}

export const quickLinks = [
  { key: 'nav.home', name: 'HomePage' },
  { key: 'nav.manufacturers', name: 'ManufacturersPage' },
  { key: 'nav.about', name: 'AboutUsPage' },
  { key: 'nav.blog', name: 'BlogPage' },
  { key: 'nav.faq', name: 'FaqPage' },
  { key: 'nav.contact', name: 'ContactUsPage' },
]